import React, { useState } from "react"
import { Fab, Tooltip, Box } from "@mui/material"
import AddIcon from "@mui/icons-material/Add"
import GridOnIcon from "@mui/icons-material/GridOn"
import TimelineIcon from "@mui/icons-material/Timeline"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import { styled } from "@mui/material/styles"

const FabContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: theme.spacing(2),
  right: theme.spacing(2),
  zIndex: 1000,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
}))

const StyledFab = styled(Fab)(({ theme }) => ({
  transition: "all 0.3s ease-in-out",
}))

const SecondaryFab = styled(Fab)(({ theme, show }) => ({
  transition: "all 0.3s ease-in-out",
  opacity: show ? 1 : 0,
  transform: show ? "scale(1)" : "scale(0)",
  pointerEvents: show ? "auto" : "none",
}))

export default function FloatingActionButtons({
  onAddArea,
  onAddLines,
  onAddMarks,
  activeArea,
}) {
  const [expanded, setExpanded] = useState(false)

  const handleToggle = () => {
    setExpanded(!expanded)
  }

  return (
    <FabContainer>
      {/* Add Marks Button - Only shown when area is active */}
      {activeArea && (
        <Tooltip title="Add Marks to Area" placement="left">
          <SecondaryFab
            color="primary"
            size="small"
            show={expanded ? 1 : 0}
            onClick={() => {
              onAddMarks()
              setExpanded(false)
            }}
          >
            <LocationOnIcon />
          </SecondaryFab>
        </Tooltip>
      )}

      {/* Add Lines Button - Only shown when area is active */}
      {activeArea && (
        <Tooltip title="Add Lines to Area" placement="left">
          <SecondaryFab
            color="primary"
            size="small"
            show={expanded ? 1 : 0}
            onClick={() => {
              onAddLines()
              setExpanded(false)
            }}
          >
            <TimelineIcon />
          </SecondaryFab>
        </Tooltip>
      )}

      {/* Add Area Button - Always shown when expanded */}
      <Tooltip title="Add Farm Area" placement="left">
        <SecondaryFab
          color="primary"
          size="small"
          show={expanded ? 1 : 0}
          onClick={() => {
            onAddArea()
            setExpanded(false)
          }}
        >
          <GridOnIcon />
        </SecondaryFab>
      </Tooltip>

      {/* Main FAB - Always shown */}
      <Tooltip title={expanded ? "Close" : "Add"} placement="left">
        <StyledFab
          color="primary"
          onClick={handleToggle}
          sx={{
            transform: expanded ? "rotate(45deg)" : "rotate(0deg)",
          }}
        >
          <AddIcon />
        </StyledFab>
      </Tooltip>
    </FabContainer>
  )
}
